exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-69515ef2]:hover{color:#5451de;text-decoration:none}", ""]);

// exports
